import React from 'react';
import { Route, Routes } from 'react-router';
import { NestedApiLocalizationProvider } from 'src/provider/LocalizationProviderConnector';
import LogsList from './LogsList';
import { useRoles } from 'src/provider/UserRoleProvider';
import { ErrorPage } from '@im/ui-lib/ErrorPage';
import { useTranslate } from '@im/react-localization';

export default function AuditLogs() {
  const { isCOGUser } = useRoles();
  const translate = useTranslate();
  return isCOGUser ? (
    <NestedApiLocalizationProvider
      preloadResources={['Common', 'Pagination', 'AuditLogs']}
    >
      <Routes>
        <Route element={<LogsList />} path="logs-list" />
      </Routes>
    </NestedApiLocalizationProvider>
  ) : (
    <ErrorPage
      data-testid="gds-vp-custom-error-page"
      errorText={translate('Common.AccessDeniedDescription')}
      message={translate('Common.CustomErrorMessage')}
    />
  );
}
